<div class="dashboard-container">

  <app-breadcrumb>
    <li class="breadcrumb-item">
      <a [routerLink]="['/dashboard']">Home</a>
    </li>
    <li class="breadcrumb-item">All Requests</li>
  </app-breadcrumb>



  <!-- Filter Card -->
  <mat-card class="mb-3 p-3 filter-card">
    <form [formGroup]="filterForm">
      <div class="row g-3 align-items-end">
        <!-- Project Multi-select -->
        <div class="col-12 col-sm-6 col-md-3 col-lg-2">
          <app-searchable-dropdown
            class="w-100"
            label="Select Project"
            formControlName="project_id"
            [multiSelect]="true"
            [options]="projectList() | searchableOptions:'project_name':'account_id'"
            placeholder="Select Project"
          ></app-searchable-dropdown>
          <div class="text-danger small mt-1" *ngIf="filterForm.get('project_id')?.hasError('required') && (filterForm.get('project_id')?.touched || filterForm.get('project_id')?.dirty || submitted)">
            Project is required
          </div>
        </div>

        <!-- Status Multi-select -->
        <div class="col-12 col-sm-6 col-md-3 col-lg-2">
          <app-searchable-dropdown
            class="w-100"
            label="Status"
            formControlName="status"
            [multiSelect]="true"
            [options]="statusList() | searchableOptions:'status':'status_id'"
            placeholder="Status"
          ></app-searchable-dropdown>
        </div>

        <!-- Category Multi-select -->
        <div class="col-12 col-sm-6 col-md-3 col-lg-2">
          <app-searchable-dropdown
            class="w-100"
            label="Category"
            formControlName="category"
            [multiSelect]="true"
            [options]="categoryList() | searchableOptions:'issue_category':'issue_category_id'"
            placeholder="Category"
          ></app-searchable-dropdown>
        </div>

        <!-- Priority Multi-select -->
        <div class="col-12 col-sm-6 col-md-3 col-lg-2">
          <app-searchable-dropdown
            class="w-100"
            label="Priority"
            formControlName="priority"
            [multiSelect]="true"
            [options]="priorityList() | searchableOptions:'priority':'priority_id'"
            placeholder="Priority"
          ></app-searchable-dropdown>
        </div>

        <!-- Assigned To Multi-select -->
        <div class="col-12 col-sm-6 col-md-3 col-lg-3">
          <app-searchable-dropdown
            class="w-100"
            label="Assigned To"
            formControlName="assignee"
            [multiSelect]="true"
            [options]="assigneeList() | searchableOptions:'display_name':'user_id'"
            placeholder="Assigned To"
          ></app-searchable-dropdown>
        </div>

        <!-- Filter Actions -->
        <div class="col-12 col-sm-6 col-md-2 col-lg-1 d-flex align-items-center">
          <button
            type="button"
            mat-icon-button
            color="primary"
            class="filter-toggle-btn"
            (click)="applyFilters()"
            matTooltip="Apply Filters"
          >
            <mat-icon>filter_alt</mat-icon>
          </button>
        </div>
      </div>
    </form>
  </mat-card>

  <!-- Empty State Message -->
  <div *ngIf="!filtersApplied()" class="empty-state-container">
    <mat-card class="empty-state-card">
      <div class="text-center py-5">
        <mat-icon class="empty-state-icon">filter_list</mat-icon>
        <h3 class="mt-3 mb-2">No Data Displayed</h3>
        <p class="text-muted mb-4">Please select filters and click "Apply Filters" to view dashboard data.</p>
      </div>
    </mat-card>
  </div>

  <!-- Loading Spinner Overlay -->
  <div *ngIf="filtersApplied() && loadingData()" class="loading-overlay">
    <div class="loading-spinner-container">
      <mat-spinner diameter="60"></mat-spinner>
      <p class="mt-3">Loading dashboard data...</p>
    </div>
  </div>

  <!-- Top Cards -->
  <div class="cards" *ngIf="filtersApplied() && !loadingData()">
    <mat-card class="card blue">
      <div class="card-content">
        <div class="card-icon">
          <mat-icon>assignment</mat-icon>
        </div>
        <div class="card-info">
          <div class="card-value">{{ totalRequests() }}</div>
          <div class="card-label">Total Requests</div>
        </div>
      </div>
    </mat-card>
    <mat-card class="card orange">
      <div class="card-content">
        <div class="card-icon">
          <mat-icon>folder_open</mat-icon>
        </div>
        <div class="card-info">
          <div class="card-value">{{ openRequests() }}</div>
          <div class="card-label">Open Requests</div>
        </div>
      </div>
    </mat-card>
    <mat-card class="card green">
      <div class="card-content">
        <div class="card-icon">
          <mat-icon>check_circle</mat-icon>
        </div>
        <div class="card-info">
          <div class="card-value">{{ closedRequests() }}</div>
          <div class="card-label">Closed Requests</div>
        </div>
      </div>
    </mat-card>
    <mat-card class="card red">
      <div class="card-content">
        <div class="card-icon">
          <mat-icon>schedule</mat-icon>
        </div>
        <div class="card-info">
          <div class="card-value">{{ pendingRequests() }}</div>
          <div class="card-label">Pending Requests</div>
        </div>
      </div>
    </mat-card>
  </div>

  <!-- Charts Grid - Bootstrap layout with Chart.js (ng2-charts) -->
  <div class="row " *ngIf="filtersApplied() && !loadingData()">
    <!-- Requests by Type -->
    <div class="col-md-6">
      <mat-card class="h-100">
        <h3 class="mb-2">Requests by Type</h3>
        <div class="chart-container" style="position: relative; height: 260px;">
          <canvas
            baseChart
            [type]="'bar'"
            [data]="requestTypeChartData"
            [options]="barChartOptions">
          </canvas>
        </div>
      </mat-card>
    </div>

    <!-- Requests by Status -->
   

    <!-- Requests by Status (Polar Area) -->
    <div class="col-md-6">
      <mat-card class="h-100">
        <h3 class="mb-2">Requests by Status (Polar Area)</h3>
        <div class="chart-container" style="position: relative; height: 260px;">
          <ng-container *ngIf="statusTotal() > 0; else noStatusData">
            <canvas
              baseChart
              [type]="'polarArea'"
              [data]="statusPieData"
              [options]="pieOptions">
            </canvas>
          </ng-container>
          <ng-template #noStatusData>
            <div class="d-flex h-100 align-items-center justify-content-center text-muted">
              No status data available to display.
            </div>
          </ng-template>
        </div>
      </mat-card>
    </div>

    <!-- Requests by Priority -->
    <!-- <div class="col-md-4">
      <mat-card class="h-100">
        <h3 class="mb-2">Requests by Priority</h3>
        <div class="chart-container" style="position: relative; height: 260px;">
          <canvas
            baseChart
            [type]="'doughnut'"
            [data]="priorityDoughnutData"
            [options]="doughnutOptions">
          </canvas>
        </div>
      </mat-card>
    </div> -->
  </div>

  <!-- Filter Card -->
  <!-- <mat-card *ngIf="showFilters" class="mb-3 p-3">
    <div class="row g-3">
      <div class="col-md-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Status</mat-label>
          <input type="search" matInput [formControl]="statusControl" [matAutocomplete]="statusAuto">
          <mat-autocomplete #statusAuto="matAutocomplete" [displayWith]="displayStatus">
            <mat-option *ngFor="let s of filteredStatusList | async" [value]="s">{{ s.status }}</mat-option>
          </mat-autocomplete>
          <mat-icon matSuffix>arrow_drop_down</mat-icon>
        </mat-form-field>
      </div>

      <div class="col-md-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Category</mat-label>
          <input type="search" matInput [formControl]="categoryControl" [matAutocomplete]="categoryAuto">
          <mat-autocomplete #categoryAuto="matAutocomplete" [displayWith]="displayCategory">
            <mat-option *ngFor="let c of filteredCategoryList | async" [value]="c">{{ c.issue_category }}</mat-option>
          </mat-autocomplete>
          <mat-icon matSuffix>arrow_drop_down</mat-icon>
        </mat-form-field>
      </div>

      <div class="col-md-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Priority</mat-label>
          <input type="search" matInput [formControl]="priorityControl" [matAutocomplete]="priorityAuto">
          <mat-autocomplete #priorityAuto="matAutocomplete" [displayWith]="displayPriority">
            <mat-option *ngFor="let p of filteredPriorityList | async" [value]="p">{{ p.priority }}</mat-option>
          </mat-autocomplete>
          <mat-icon matSuffix>arrow_drop_down</mat-icon>
        </mat-form-field>
      </div>

      <div class="col-md-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Assigned To</mat-label>
          <input type="search" matInput [formControl]="assigneeControl" [matAutocomplete]="assigneeAuto">
          <mat-autocomplete #assigneeAuto="matAutocomplete" [displayWith]="displayAssignee">
            <mat-option *ngFor="let a of filteredAssigneeList | async" [value]="a">{{ a.first_name }} {{ a.last_name }}</mat-option>
          </mat-autocomplete>
          <mat-icon matSuffix>arrow_drop_down</mat-icon>
        </mat-form-field>
      </div>
    </div>

    <div class="mt-3 d-flex justify-content-end">
      <button mat-stroked-button color="warn" (click)="clearFilters()">Clear Filters</button>
    </div>
  </mat-card> -->

  <!-- Requests Table -->
  <div class="row mt-4" *ngIf="filtersApplied() && !loadingData()">
    <div class="col-12">
      <ng-template #priorityCell let-row>
        <span [ngClass]="{
          'priority-high': row.priority_name === 'High',
          'priority-medium': row.priority_name === 'Medium',
          'priority-low': row.priority_name === 'Low',
          'priority-urgent': row.priority_name === 'Urgent'
        }">
          {{ row.priority_name || '-' }}
        </span>
      </ng-template>
      <ng-template #descriptionCell let-row>
        <span
          class="description-cell"
          [matTooltip]="row.description"
          matTooltipPosition="above"
        >
          {{ row.description || '-' }}
        </span>
      </ng-template>
      <ng-template #approvedCell let-row>
        <span [ngClass]="{
          'approved': row.approved === 'approved',
          'unapproved': row.approved === 'unapproved'
        }">
          {{ row.approved }}
        </span>
      </ng-template>
      <ng-template #commentsActions let-row>
        <button
          (click)="openComments(row.issue_id); $event.stopPropagation()"
          mat-icon-button
          aria-label="Open forum"
        >
          <mat-icon>forum</mat-icon>
        </button>
      </ng-template>
      <app-custom-table-view
        [columns]="tableColumns"
        [data]="tableData"
        [loading]="loading()"
        [showDefaultActions]="false"
        [actionsTemplate]="commentsActions"
        exportFileName="admin-requests.xlsx"
        (rowClick)="openEditDialog($event)"
        (refresh)="applyFilters()"
      ></app-custom-table-view>
    </div>
  </div>

</div>
